import React from 'react';
import { withRouter } from 'react-router-dom';

import http from 'api/http';
import { inspectionAPI } from 'api/requests';

import Header from './Header';
import Report from './Report';
import Response from './Response';
import { STATUS } from 'constants/index';
import Actions from './Actoins';
import ApplicationActions from 'Components/ApplicationActions';

@withRouter
export default class Details extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: '',
      description: '',
      status: '',
      year: '',
      inspectionDate: '',
      documents: [],
      requestInProcess: false,
    };
  }

  componentDidMount() {
    const { inspectionId } = this.props.match.params;

    if (isFinite(inspectionId)) {
      this.setState({ requestInProcess: true }, () => {
        http.get(inspectionAPI.inspectionDetails(inspectionId)).then(({ data: inspection }) => {
          inspection.address = [
            inspection.mnfAddress,
            inspection.mnfCity,
            inspection.mnfState,
            inspection.mnfPostalCode,
            inspection.mnfCountryId,
          ]
            .filter(object => object)
            .join(', ');
          this.setState({ ...inspection, requestInProcess: false });
        });
      });
    }
  }

  _updateStatus = entry => {
    let state = {};

    if (entry.response !== undefined) {
      state = entry;
    } else {
      state.response = entry;
    }

    this.setState(state);
  };

  performAction = (action, id) => () => {
    const { performAction } = this.props;

    performAction(action, id, this._updateStatus)();
  };

  render() {
    const { id, status, response, requestInProcess, vresponseRequired } = this.state;
    const {
      getReadableStatus,
      handleGoBackClick,
      createActionList,
      markStepAsRedacted,
      handleSubmitReport,
      user,
      getDetailsLink,
    } = this.props;

    const showResponse = status !== STATUS.INCOMPLETE && vresponseRequired;
    const actions = createActionList(this.state);

    return (
      <section className='scene__scene-wrapper'>
        <section className='scene__content-wrapper'>
          {!requestInProcess && (
            <React.Fragment>
              <Header
                inspection={this.state}
                user={user}
                id={id}
                actions={actions}
                performAction={this.performAction}
                readableStatus={getReadableStatus(this.state)}
                handleGoBackClick={handleGoBackClick}
              />
              <Report
                {...this.state}
                user={user}
                getDetailsLink={getDetailsLink}
                inspector={this.state.user}
                inspectionId={id}
                handleSubmitReport={handleSubmitReport}
                markStepAsRedacted={markStepAsRedacted}
                createActionList={createActionList}
                handleGoBackClick={handleGoBackClick}
              />

              {showResponse && <Response response={response} />}

              <Actions
                reportStatus={status}
                id={id}
                responseId={response ? response.id : null}
                user={user}
                performAction={this.performAction}
                actions={actions}
              />

              <ApplicationActions backButtonLabel='Back' backButtonAction={handleGoBackClick} />
            </React.Fragment>
          )}
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Details/index.jsx